export default {
    title: 'Welcome to the Trendmanager',
    description: ''
}
